<div class="esri-component esri-widget--button esri-widget previous" role="button" tabindex="0" (click)="onClick()">
  <span class="esri-icon esri-icon-left-arrow" title="Zoom to previous extent"></span>
  <span class="esri-icon-font-fallback-text">Zoom to previous extent</span>
</div>
